import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  private setSession(token) {
    localStorage.setItem('token', token);
  }

  private cleanSession() {
    localStorage.removeItem('token');
    localStorage.removeItem('verified');
    localStorage.removeItem('admin');
  }


  login(token) {
    this.setSession(token);
  }

  logout() {
    this.cleanSession();
  }

  isLoggedIn() {
    return localStorage.getItem('token');
  }

  setVerified(val){
    localStorage.setItem('verified', val);
  }

  isVerified(): boolean {
    return localStorage.getItem('verified') === 'true';
  }

  setAdminUser(val){
    localStorage.setItem('admin', val);
  }

  isAdmin():boolean {
    return localStorage.getItem('admin') === 'true';
  }


}
